/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 28.04.2016.
 */

import React, {Component, PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {VelocityComponent} from 'velocity-react';

import {SetPlayer} from '../../actions/common/actions-common';
import {ACTIONS} from '../../containers/Player';

import Tile from '../../components/ShowcaseCollection/Tile';
import Profile from '../../components/ShowcaseCollection/Profile';

class ShowcaseRow extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isExtended: false,
      selectedAsset: null,
      sel_row: null,
      sel_col: null
    }
  }

  componentWillReceiveProps(newProps) {

    if (!newProps.isExtend && this.props.isExtend) {

      this.props.SetPlayer({
        stream_url: '',
        container: null,
        action: ACTIONS.CLOSE,
        monitoring: null
      });
    }
  }

  _onAssetSelect(asset, row, col) {

    this.setState({
      selectedAsset: {
        id: asset.id,
        type: asset.type,
        package_type: asset.package_type
      }
    });

    this.props.onExtendRow(row, col);
  }

  _onClose() {

    this.props.onExtendRow(null, null);
  }

  _onAnimationComplete() {

    if (!this.props.isExtend) {
      this.setState({selectedAsset: null});

    }
  }

  _renderTiles() {

    return this.props.assets.map((asset, index) => {

      return (
        <Tile
          key={`tile_${this.props.row}_${index}`}
          asset={asset}
          row={this.props.row}
          col={index}
          isSelected={this.props.sel_row === this.props.row && this.props.sel_col === index && this.props.isExtend }
          onAssetSelect={this._onAssetSelect.bind(this)} />
      );
    });
  };

  render() {

    let animationOnExpand = {
      marginTop: this.props.isExtend ? 0 : '-270px',
      marginBottom: this.props.isExtend ? '6px' : 0
    };

    return (
      <div className="profile-container">
        <VelocityComponent animation={animationOnExpand} complete={this._onAnimationComplete.bind(this)} duration={650}>
          <Profile entity={this.props.isExtend ? this.state.selectedAsset : null} onClose={this._onClose.bind(this)} />
        </VelocityComponent>
        <div id="showcase_row" className="showcase-row-container">
          <div className="blocks-row clearfix showcase-row">
            { this._renderTiles() }
          </div>
        </div>
      </div>
    );
  }
}

ShowcaseRow.propTypes = {
  assets: PropTypes.array.isRequired
};

const mapStateToProps = () => {

  return {};
};

const mapDispatchToProps = (dispatch) => {

  return bindActionCreators({SetPlayer}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(ShowcaseRow);



// WEBPACK FOOTER //
// ./src/components/ShowcaseCollection/showcase-collection-row.js